import { reactive, markRaw, createApp, readonly } from "vue";
import FhToastContainer from "../FhToastContainer/FhToastContainer.mjs";
import { generateUniqueId } from "../../utils.mjs";
import { VARIANTS_ENUMS } from "../constants.mjs";
class ToastService {
  constructor() {
    this.toasts = reactive([]);
    this.toastApp = null;
    this.containerDiv = null;
    this.hideToast = this.hideToast.bind(this);
    this.showToast = this.showToast.bind(this);
    this.mountToastContainer();
  }
  hideToast(id) {
    var _a, _b;
    const index = this.toasts.findIndex((toast) => toast.id === id);
    if (index > -1) {
      (_b = (_a = this.toasts[index].options) == null ? void 0 : _a.onClose) == null ? void 0 : _b.call(_a);
      this.toasts.splice(index, 1);
    }
  }
  showToast(content, {
    props = {},
    variant = VARIANTS_ENUMS.SUCCESS,
    duration = 4e3,
    dismissible = true,
    onClose = null,
    autoClose = true
  } = {}) {
    const toast = {
      id: generateUniqueId(),
      content: markRaw(content),
      options: { variant, dismissible, duration, onClose, autoClose },
      props,
      hideToast: this.hideToast
    };
    this.toasts.push(toast);
    return toast;
  }
  mountToastContainer() {
    if (!this.containerDiv) {
      this.containerDiv = document.createElement("div");
      document.body.appendChild(this.containerDiv);
    }
    this.toastApp = createApp(FhToastContainer, {
      toasts: readonly(this.toasts),
      hideToast: this.hideToast
    });
    this.toastApp.mount(this.containerDiv);
  }
}
const FhToastService = new ToastService();
export {
  ToastService,
  FhToastService as default
};
//# sourceMappingURL=FhToastService.mjs.map
